document.addEventListener("DOMContentLoaded", () => {
    const clickHandler = panelTabs => {
        Array.prototype.forEach.call(panelTabs, panelTab => {
            panelTab.addEventListener('click', event => {
                togglePanel(event, panelTabs);
            });

            const panel = panelTab.nextElementSibling;
            const focusable = panel.querySelectorAll('a, button')

            focusable.forEach(el => {
                el.setAttribute('tabIndex', -1)
            })
        });
    }

    const togglePanel = (event, allPanelTabs) => {
        const currentPanelTab = event.currentTarget;
        if (currentPanelTab.dataset.open === 'true') currentPanelTab.dataset.open = 'false';

        if (currentPanelTab.classList.contains('is-open')) {
            collapse(currentPanelTab);
        } else {
            Array.prototype.forEach.call(allPanelTabs, panelTab => {
                if (panelTab.dataset.open === 'true') panelTab.dataset.open = 'false';
                collapse(panelTab);
            });
            
            expand(currentPanelTab);
        }
    }

    const collapse = panelTab => {
        const listItem = panelTab.closest('li');
        const panel = listItem.querySelector('.panel');

        panelTab.classList.remove('is-open');
        panelTab.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.maxHeight = null;

        const focusable = panel.querySelectorAll('a, button')

        focusable.forEach(el => {
            el.setAttribute('tabIndex', -1)
        })
    };

    const expand = panelTab => {
        const reciteElement = panelTab.closest('recite');
        const panel = reciteElement ? reciteElement.nextElementSibling : panelTab.nextElementSibling;

        panelTab.classList.add('is-open');
        panelTab.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.maxHeight = panel.scrollHeight + 'px';

        const focusable = panel.querySelectorAll('a, button')

        focusable.forEach(el => {
            el.removeAttribute('tabIndex')
        })
    };

    const accordions = document.querySelectorAll('.accordion-block');

    if (accordions.length > 0) {
        Array.prototype.forEach.call(accordions, accordion => {

            const openOnLoad = accordion.querySelectorAll('[data-open]');
            const panelTabs = accordion.querySelectorAll('.panel-title');

            if (openOnLoad.length > 0) {
                if (detectIE()) {
                    // delay needed for CSS Vars polyfill to do it's magic on IE11 otherwise height is calculated incorrectly
                    Array.prototype.forEach.call(openOnLoad, openPanel => {
                        setTimeout(function () {
                            expand(openPanel)
                        }, 500);
                    });
                } else {
                    Array.prototype.forEach.call(openOnLoad, openPanel => {
                        expand(openPanel)
                    });
                }
            }

            if (panelTabs.length > 0) {
                clickHandler(panelTabs);
            }
        });
    }
});
